// Audit API client
const API = '/api/core/audit';

async function jfetch(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    credentials: 'include',
    ...options,
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try { const j = await res.json(); detail = j.detail || JSON.stringify(j); } catch { /* */ }
    const err = new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return res.status === 204 ? null : res.json();
}

export const audit = {
  run: () => jfetch('/run', { method: 'POST' }),
  summary: () => jfetch('/summary'),
  inventory: ({ item_type, owner_area, limit = 1000 } = {}) => {
    const p = new URLSearchParams();
    if (item_type) p.set('item_type', item_type);
    if (owner_area) p.set('owner_area', owner_area);
    p.set('limit', limit);
    return jfetch(`/inventory?${p.toString()}`);
  },
  findings: ({ severity, area, rule_code, status, limit = 500 } = {}) => {
    const p = new URLSearchParams();
    if (severity) p.set('severity', severity);
    if (area) p.set('area', area);
    if (rule_code) p.set('rule_code', rule_code);
    if (status) p.set('status', status);
    p.set('limit', limit);
    return jfetch(`/findings?${p.toString()}`);
  },
  patchFinding: (id, body) => jfetch(`/findings/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  runs: () => jfetch('/runs'),
  moduleMap: () => jfetch('/module-map'),
};

export default audit;
